<main>
  <loading-overlay [isLoading]="isChangingDyeingMachine()" />
  <header>
    <div class="headline">
      <h1>{{ 'Individual_Production_Card_Details_ProductionCardDetails' | translateWF: 'Production Card Details' }}</h1>
      @if (productionCard && showSelect() && !isMainViewerOnly && isProductionCardsEditor) {
        <p-select [options]="selectOptions()" [formControl]="status" />
      } @else {
        <span> {{ productionCardStatusValues[productionCard?.status!] }}</span>
      }
    </div>
    <div class="buttons">
      @if (showTransferReportsButton()) {
        <p-select
          [options]="availableTransferReports()"
          optionLabel="label"
          [placeholder]="'Individual_Production_Card_Details_DownloadReport' | translateWF: 'Download Report'"
          (onChange)="downloadTransferReport($event.value)"
        >
          <ng-template pTemplate="selectedItem">
            <span><i class="pi pi-download mr-2"></i>{{ 'Individual_Production_Card_Details_DownloadReport' | translateWF: 'Download Report' }}</span>
          </ng-template>
        </p-select>
      }
      @if (canChangeDyeingMachine) {
        <p-button [label]="'Change_Machine' | translateWF: 'Change Machine'" icon="pi pi-sync" variant="outlined" (onClick)="openChangeDyeingMachineModal()" />
      }
      @if (canCloseProductionCard) {
        <p-button
          [label]="'Close_Production_Card' | translateWF: 'Close Production Card'"
          icon="pi pi-lock"
          severity="danger"
          [loading]="isClosing()"
          (onClick)="openCloseProductionCardModal()"
        />
      }
      @if (canToggleReassignment) {
        @if (productionCard?.status === productionCardStatus.Closed) {
          <p-button [label]="'Enable_Reassignment' | translateWF: 'Enable Reassignment'" icon="pi pi-arrow-right-arrow-left" severity="warn" (onClick)="openReassignmentModal()" />
        } @else {
          <p-button [label]="'Return_To_Closed' | translateWF: 'Return to Closed'" icon="pi pi-lock" severity="secondary" (onClick)="openReassignmentModal()" />
        }
      }
    </div>
  </header>

  <div class="pc-details-content relative overflow-hidden">
    <div class="grid-1 xl:grid-cols-[1fr_minmax(460px,35%)] h-full w-full">
      <!-- Left Panel -->
      <div class="flex flex-col h-full px-[2rem] pb-16 overflow-y-auto custom-scrollbar">
        <app-individual-production-card-general-information
          [showOrderInfo]="true"
          [showDyeingInfo]="true"
          [showManufacturerTable]="true"
          [showBalanceTable]="true"
          [rolls]="rolls()"
        />
      </div>

      <!-- Right Panel -->
      <div class="h-full px-[2rem] pb-16 overflow-y-auto custom-scrollbar border-l border-gray-200 flex flex-col gap-[2rem]">
        <p-panel header="Stations">
          <div class="steps-scrollable col min-h-[400px]">
            @if (batchingCardViewMode !== null) {
              <p-card>
                <ng-template pTemplate="header">
                  <h3>{{ 'Individual_Production_Card_Details_Bundles' | translateWF: 'Bundles' }}</h3>
                </ng-template>

                <div class="col">
                  @if (batchingCardViewMode === 'bundles') {
                    @for (item of bundleStatusSummary; track item.label) {
                      <div class="row-start-center">
                        <span>{{ item.label }}</span>
                        <p-tag [value]="item.count.toString()" [severity]="item.severity" />
                      </div>
                    }
                  }
                </div>

                <ng-template pTemplate="footer">
                  <p-button [label]="'Individual_Production_Card_Details_GoToBundles' | translateWF: 'Go to Bundles'" (onClick)="goToBundles()" />
                </ng-template>
              </p-card>

              @if (dyeingCycles().length > 0) {
                <p-card styleClass="finishing-routes-card">
                  <ng-template pTemplate="header">
                    <div class="card-header-custom">
                      <h3>{{ 'Individual_Production_Card_Details_DyeingCycleRuns' | translateWF: 'Dyeing Cycle Runs' }}</h3>
                      <p-tag [value]="dyeingCyclesStatus.label" [severity]="dyeingCyclesStatus.severity" />
                    </div>
                  </ng-template>
                  <div class="dyeing-cycles-list">
                    @for (cycle of dyeingCycles(); track cycle.id; let idx = $index) {
                      <div class="cycle-item">
                        <div class="cycle-header">
                          <span class="cycle-name"
                            >{{ cycle.startStationAssetId }} - ({{ 'Individual_Production_Card_Details_Cycle' | translateWF: 'Cycle' }} #{{ cycle.cycleNumber }})</span
                          >
                        </div>
                        <div class="cycle-dates">
                          [{{ cycle.startTime | date: 'dd/MM/yy HH:mm' }}] - [{{
                            cycle.endTime ? (cycle.endTime | date: 'dd/MM/yy HH:mm') : ('Individual_Production_Card_Details_InProgress' | translateWF: 'In Progress')
                          }}]
                        </div>
                        <div class="row-start-center">
                          <p-tag [value]="getColorStatusApproval(cycle).label" [severity]="getColorStatusApproval(cycle).severity" />
                          @if (cycle.endTime) {
                            <p-button [label]="'Recipe_Values' | translateWF: 'Recipe Values'" size="small" icon="pi pi-calculator" (onClick)="goToCycleRecipeValues(cycle.id)" />
                          }
                        </div>
                      </div>
                    }
                  </div>
                </p-card>
              }
            }

            @if (finishingRoutes().length > 0) {
              <p-card styleClass="finishing-routes-card">
                <ng-template pTemplate="header">
                  <div class="card-header-custom">
                    <h3>{{ 'Individual_Production_Card_Details_FinishingRoutes' | translateWF: 'Finishing Routes' }}</h3>
                    <p-tag [value]="finishingRoutesStatus.label" [severity]="finishingRoutesStatus.severity" />
                  </div>
                </ng-template>
                @if (hasRoutesWithRollingPending()) {
                  <p-message severity="warn" styleClass="mb-3 p-2 ml-2 mr-2">
                    {{
                      'Individual_Production_Card_Details_TheRoutesHaveRollingProcess'
                        | translateWF
                          : 'The routes have a
                Rolling process and will require transfer'
                    }}
                  </p-message>
                }
                <p-stepper orientation="vertical" styleClass="finishing-routes-stepper" [value]="0">
                  @for (route of finishingRoutes(); track route.id; let idx = $index) {
                    <p-step-item [value]="idx + 1">
                      <p-step>
                        <div class="step-header-content">
                          <span class="route-name">{{ route.number }}</span>
                          @if (isRouteCompleted(route)) {
                            <span class="route-status">({{ 'Individual_Production_Card_Details_Completed' | translateWF: 'completed' }})</span>
                          } @else if (isRoutePendingRolling(route)) {
                            <span class="route-status">({{ 'Individual_Production_Card_Details_PendingRollingProcess' | translateWF: 'Pending Rolling Process' }})</span>
                          }
                        </div>
                      </p-step>
                      <p-step-panel>
                        <ng-template #content let-activateCallback="activateCallback">
                          <div class="route-details border-dashed border-2 p-4 rounded-md mb-4 mr-8 bg-slate-400 bg-opacity-10">
                            <p class="route-info">
                              <strong>{{ getFabric(route) }}</strong> - <strong>{{ getFabricType(route) }}</strong>
                            </p>
                            <p class="route-info">
                              <strong>{{ 'Individual_Production_Card_Details_Processes' | translateWF: 'Processes' }}:</strong>
                              {{ getCompletedProcessesCount(route) }}/{{ getTotalProcessesCount(route) }}
                            </p>
                            <p class="route-info">
                              <strong>{{ 'Individual_Production_Card_Details_Rolls' | translateWF: 'Rolls' }}:</strong>
                              {{ getRollsCount(route) }}
                            </p>
                          </div>
                          <div class="flex items-center gap-3">
                            <p-button [label]="'Individual_Production_Card_Details_Settings' | translateWF: 'Settings'" size="small" (onClick)="goToFinishingRoute(route.number)" />
                            <p-button size="small" (onClick)="printReport(route)">
                              <ng-template pTemplate="icon">
                                <i class="pi pi-print py-0.5"></i>
                              </ng-template>
                            </p-button>
                          </div>
                        </ng-template>
                      </p-step-panel>
                    </p-step-item>
                  }
                </p-stepper>
              </p-card>
            }
            @if (showFinishedGoodsCard) {
              <p-card>
                <ng-template pTemplate="title">
                  {{ 'Individual_Production_Card_Details_FinishedGoods' | translateWF: 'Finished Goods' }}
                </ng-template>
                <p class="text-gray-600">
                  @if (productionCard?.status === productionCardStatus.Finishing) {
                    {{
                      'Individual_Production_Card_Details_ProductionCardInFinishingStage'
                        | translateWF: 'Production card is in Finishing stage. Move rolls to Finished Goods when ready.'
                    }}
                  } @else if (productionCard?.status === productionCardStatus.FinishedGood) {
                    {{
                      'Individual_Production_Card_Details_ProductionCardMovedToFinishedGoods'
                        | translateWF
                          : 'Production card
                has been moved to Finished Goods.'
                    }}
                  }
                </p>
                <ng-template pTemplate="footer">
                  <p-button [label]="'Individual_Production_Card_Details_GoToFinishedGoods' | translateWF: 'Go to Finished Goods'" (onClick)="goToFinishedGoods()" />
                </ng-template>
              </p-card>
            }
          </div>
        </p-panel>
      </div>
    </div>
  </div>
</main>
